export const isProduction = process.env.NODE_ENV === 'production';

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function loadScriptAsync(src, containerSelector = 'body') {
    return new Promise((resolve, reject) => {
        if (Array.from(document.querySelectorAll(`script[src="${ encodeURI(src) }"`)).length) {
            return resolve();
        }

        const s = document.createElement('script');
        s.async = true;
        s.onerror = reject;
        s.onload = resolve;
        s.src = src;
        const container = (containerSelector && document.querySelector(containerSelector)) || document.body;
        container.appendChild(s);
    });
}

export function sortByKey(array, key) {
    if (!array || !key) {
        return array;
    }

    return array
        .slice()
        .sort((a, b) => {
            return a[key] - b[key];
        });
}
